import {
  Stack,
  Heading,
  Text,
  OrderedList,
  ListItem,
  UnorderedList,
  Divider,
} from "@chakra-ui/react";
import { aboutText } from "../constants/About";
import { MetaTag } from "../utils/MetaTag";

const AboutPage = () => {
  return (
    <Stack
      gap={4}
      px={8}
      pt={4}
      pb={12}
      align="center"
      w="100%"
      h="100%"
      fontSize={14}
    >
      <MetaTag
        title="Tentang | BisnisLink"
        description="BisnisLink adalah platform reseller untuk promosi produk UMKM. Kami membantu UMKM untuk memperluas jangkauan pasar dengan memanfaatkan reseller."
      />

      <Stack w="100%" maxW="600px" textAlign="center">
        <Heading as="h2" mt={4} fontSize={14}>
          Tentang Kami
        </Heading>
      </Stack>
      <Stack w="100%" maxW="600px" textAlign="justify">
        <Heading as="h1" fontSize={24} mb={4} textAlign="center">
          <Text as="b" color="red.500">
            BisnisLink
          </Text>
          : Platform Reseller untuk Promosi Produk UMKM
        </Heading>
        <Divider />
        {aboutText.description.map((desc, index) => (
          <Text key={index}>{desc}</Text>
        ))}
        <OrderedList spacing={4}>
          {aboutText.sections.map((section, index) => (
            <ListItem fontWeight={600} key={index}>
              {section.title}
              <UnorderedList mt={2} spacing={2} fontWeight={400}>
                {section.description.map((desc, index) => (
                  <ListItem key={index}>{desc}</ListItem>
                ))}
              </UnorderedList>
            </ListItem>
          ))}
        </OrderedList>
      </Stack>
    </Stack>
  );
};

export default AboutPage;
